@if (isServiceDown) {
  <div class="offline-container">
    <div class="offline-content">
      <i class="pi pi-exclamation-triangle"></i>
      <h2>{{ 'Service Temporarily Unavailable' | translate }}</h2>
      <p>{{ 'We are experiencing technical difficulties. Please try again shortly.' | translate }}</p>
      <button mat-flat-button color="primary" (click)="retryConnection()">
        {{ 'Retry' | translate }}
      </button>
    </div>
  </div>
} @else if (isSuspended) {
  <div class="offline-container">
    <div class="offline-content">
      <i class="pi pi-lock"></i>
      <h2>{{ 'Service suspended' | translate }}</h2>
      <p>{{ 'The booking system of this club is temporarily suspended. Please contact Actively.' | translate }}</p>
      <a mat-flat-button color="primary" href="mailto:info&#64;actively.gr">info&#64;actively.gr</a>
    </div>
  </div>
} @else {
  <app-header class="header"></app-header>
  <app-drawer-menu class="drawer-wrapper">
    @if (!isOnline) {
      <div class="offline-container">
        <div class="offline-content">
          <i class="pi pi-wifi-off"></i>
          <h2>{{ 'No Internet Connection' | translate }}</h2>
          <p>{{ 'Please check your connection and try again.' | translate }}</p>
          <button mat-flat-button color="primary" (click)="isOnline = true">
            {{ 'Retry' | translate }}
          </button>
        </div>
      </div>
    } @else {
      <main class="main-outlet">
        <div class="content-wrapper">
          <router-outlet></router-outlet>
        </div>
        <app-footer class="footer"></app-footer>
      </main>
    }
  </app-drawer-menu>
  <app-loader></app-loader>
}
